import { getTranslation } from '../services/i18n/i18nUtils'
import { i18nLocalesName, isI18nLocale } from './translate-helpers/locales'

export const getI18nLocaleName = (locale: unknown): string | undefined =>
  isI18nLocale(locale) ? getTranslation(i18nLocalesName[locale]) : undefined
